// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymentWaiting_container__97Nf6 {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #0D0E11;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Background Gradient SVG */
.paymentWaiting_backgroundGradient__2cCq5 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.paymentWaiting_backgroundSvg__cqNzm {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  min-width: 360px;
  min-height: 684px;
}

/* Main Content */
.paymentWaiting_content__7E1eh {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
  width: 100%;
  max-width: 360px;
  padding: 0 16px;
  margin-bottom: 40px;
}

/* Icon */
.paymentWaiting_iconContainer__EbzHH {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 46px;
  background-color: transparent;
  padding: 0;
  line-height: 0;
}

.paymentWaiting_icon__e18tz {
  width: 152px;
  height: 44px;
  display: block;
  object-fit: contain;
}

/* Title */
.paymentWaiting_title__BSeE3 {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  color: #F3F4F6;
  text-align: center;
  margin: 0;
  margin-bottom: 44px;
  max-width: 312px;
}

/* Timer Box */
.paymentWaiting_timerBox__mP7cn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  background-color: rgba(53, 57, 69, 0.8);
  border-radius: 12px;
  margin-bottom: 24px;
  backdrop-filter: blur(10px);
}

.paymentWaiting_timerText__QHAXr {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #C1C3CF;
}

.paymentWaiting_timerValue__h7sBZ {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #FFA726;
  margin: 0 2px;
}

/* Warning Text */
.paymentWaiting_warningText__p2L3h {
  position: fixed;
  bottom: 32px;
  left: 56px;
  right: 56px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #C1C3CF;
  text-align: center;
  margin: 0;
  z-index: 1;
}



/* Responsive */
@media (max-width: 360px) {
  .paymentWaiting_content__7E1eh {
    max-width: 100%;
  }

  .paymentWaiting_retryButton__J9ea3 {
    width: calc(100% - 64px);
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/trial/PaymentWaiting/paymentWaiting.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;;;AAIA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  position: relative;\n  width: 100%;\n  min-height: 100vh;\n  background-color: #0D0E11;\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Background Gradient SVG */\n.backgroundGradient {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.backgroundSvg {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  height: 100%;\n  min-width: 360px;\n  min-height: 684px;\n}\n\n/* Main Content */\n.content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  width: 100%;\n  max-width: 360px;\n  padding: 0 16px;\n  margin-bottom: 40px;\n}\n\n/* Icon */\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 46px;\n  background-color: transparent;\n  padding: 0;\n  line-height: 0;\n}\n\n.icon {\n  width: 152px;\n  height: 44px;\n  display: block;\n  object-fit: contain;\n}\n\n/* Title */\n.title {\n  font-family: 'Inter', sans-serif;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #F3F4F6;\n  text-align: center;\n  margin: 0;\n  margin-bottom: 44px;\n  max-width: 312px;\n}\n\n/* Timer Box */\n.timerBox {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 24px;\n  background-color: rgba(53, 57, 69, 0.8);\n  border-radius: 12px;\n  margin-bottom: 24px;\n  backdrop-filter: blur(10px);\n}\n\n.timerText {\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #C1C3CF;\n}\n\n.timerValue {\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  color: #FFA726;\n  margin: 0 2px;\n}\n\n/* Warning Text */\n.warningText {\n  position: fixed;\n  bottom: 32px;\n  left: 56px;\n  right: 56px;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #C1C3CF;\n  text-align: center;\n  margin: 0;\n  z-index: 1;\n}\n\n\n\n/* Responsive */\n@media (max-width: 360px) {\n  .content {\n    max-width: 100%;\n  }\n\n  .retryButton {\n    width: calc(100% - 64px);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `paymentWaiting_container__97Nf6`,
	"backgroundGradient": `paymentWaiting_backgroundGradient__2cCq5`,
	"backgroundSvg": `paymentWaiting_backgroundSvg__cqNzm`,
	"content": `paymentWaiting_content__7E1eh`,
	"iconContainer": `paymentWaiting_iconContainer__EbzHH`,
	"icon": `paymentWaiting_icon__e18tz`,
	"title": `paymentWaiting_title__BSeE3`,
	"timerBox": `paymentWaiting_timerBox__mP7cn`,
	"timerText": `paymentWaiting_timerText__QHAXr`,
	"timerValue": `paymentWaiting_timerValue__h7sBZ`,
	"warningText": `paymentWaiting_warningText__p2L3h`,
	"retryButton": `paymentWaiting_retryButton__J9ea3`
};
export default ___CSS_LOADER_EXPORT___;
